export const batchTableHeaders = [
  "Batch Number",
  "Manufacture Date",
  "Expiry Date",
  "Available Qty",
  // MED-659 (UC-LST-02): the batch's effective price after any clearance
  // discount, derived from the product's listing.
  "Price",
  "Action",
];
export const batchTableKeys = [
  "batch_number",
  "manufacture_date",
  "expiry_date",
  "quantity_in_stock",
  "price",
  "action",
];

// Client-side filter fields for the batch table — the /batches endpoint
// returns the full unpaginated list for a product, so search/filter are
// applied locally rather than as query params.
export const batchTableFilterOptions = [
  {
    name: "manufacture_date",
    label: "Manufacture Date",
    type: "date",
  },
  {
    name: "expiry_date",
    label: "Expiry Date",
    type: "date",
  },
];

// Mutable fields per InventoryConcern#update_params on the backend — batch
// identity (batch_number/dates/cost) is immutable after creation.
//
// MED-659 removed the per-batch "Selling price per unit" field from this form.
// Price is now a property of the seller's LISTING, held once per product and
// derived to every level and batch; editing it here would write the legacy
// mirror column (inventories.selling_price_per_unit) and immediately diverge
// from the listing everything else derives from. Price is set in the Selling
// Level & Price module, and discounted per batch via the discount action.
//
// MED-698 drops "Selling Package Type" the same way, but only for a seller whose
// level is DERIVED. A manufacturer sells the product's outermost layer because
// that is what they build, so there is nothing here for them to choose — the
// same reason SellingLevelPriceModal replaces its picker with a statement of the
// level for them. The field is not narrowed to a single option, because a
// "choose one" control over one entry still implies a choice exists. Every
// reseller below them breaks bulk and keeps the full dropdown, unchanged.
export function buildEditBatchForm(
  packageTypeOptions: { id: string; title: string }[],
  sellingLevelDerived: boolean,
) {
  const sellingPackageTypeField = {
    inputType: "selectInput",
    prompt: "Selling Package Type",
    name: "selling_package_type",
    placeholder: "Select a package type",
    fullWidth: false,
    returnId: true,
    options: packageTypeOptions,
  };

  return [
    ...(sellingLevelDerived ? [] : [sellingPackageTypeField]),
    {
      inputType: "number",
      prompt: "Reorder Level",
      name: "reorder_level",
      placeholder: "Enter the reorder level",
      fullWidth: false,
    },
    {
      inputType: "number",
      prompt: "Reorder Quantity",
      name: "reorder_quantity",
      placeholder: "Enter the reorder quantity",
      fullWidth: false,
    },
    {
      inputType: "number",
      prompt: "Quantity Defective",
      name: "quantity_defective",
      placeholder: "Enter quantity defective",
      fullWidth: false,
    },
  ];
}
